var template = require('./trusted_contact_person.html.slim')
declare var angular

export class TrustedContactPersonController {
  static $inject = ['locale', 'TrustedContactPersons', 'users', '$scope', '$routeParams']

  userLocale: null
  trustedContactPersons: any[]
  error: null
  isLoading: Boolean
  userId: String

  constructor(private locale, private TrustedContactPersons, private users, public $scope, private $routeParams) {
    this.userLocale = this.locale.getLocale();
    this.isLoading = false;

    if (this.users.getCurrentUser().roles.includes('staff')) {
      this.userId = this.$routeParams.userId;
    } else {
      this.userId = this.users.getCurrentUser().id;
    }

    Promise.all([this.getTrustedContactPersons()])
  }

  removeTrustedContactPerson() {
    this.isLoading = true;
    this.TrustedContactPersons.delete({id: this.userId }).$promise
      .then(res => {
        this.$scope.removeTrustedContactPersonDialog.hide();
        this.getTrustedContactPersons();
        this.isLoading = false;
      })
  }

  getTrustedContactPersons() {
    return this.TrustedContactPersons.get({id: this.userId }).$promise
      .then(res => {
        this.trustedContactPersons = res.result;
      })
  }

  getTcpUrl() {
    if (this.userLocale === 'fr-ca') {
      return 'https://help.cidirectinvesting.com/ouvrir-un-compte/personne-ressource-de-confiance';
    } else {
      return 'https://help.cidirectinvesting.com/opening-an-account/what-is-a-trusted-contact-person';
    }
  }
}

angular.module('wbComponents')
  .controller("TrustedContactPersonController", TrustedContactPersonController)
  .directive('trustedContactPerson', function() {
    return {
      restrict: 'E',
      templateUrl: template,
      controller: "TrustedContactPersonController",
      controllerAs: 'ctrl',
      replace: true,
    }
  });
